import React from 'react'
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP } from 'constants/ThemeConstant';
import { APP_NAME } from 'configs/AppConfig';
import { connect } from "react-redux";
import utils from 'utils';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navCollapsed, navType } = props;
  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  if(isMobile && !props.mobileLogo) {
    return 0
  }
  if(isNavTop) {
    return 'auto'
  }
  if(navCollapsed) {
    return `${SIDE_NAV_COLLAPSED_WIDTH}px`
  } else {
    return `${SIDE_NAV_WIDTH}px`
  }
}

// const getLogo = (props) => {
//   const { navCollapsed, logoType } = props;
//   if(logoType === 'light') {
//     if(navCollapsed) {
//       return '/img/KowrIcon.png'
//     }
//     return '/img/Kowri_Logo-04.png'
//   }

//   if (navCollapsed) {
//     return '/img/KowrIcon.png'
//   }
//   return '/img/LightTheme.png'
// }

const getLogo = (props) => {
  const { navCollapsed, logoType } = props;
  const path = window.location.pathname.split('/')[1]; // Get the first segment of the path

  // Check the path and render the appropriate set of logos
  if (path === 'app') {
    if (logoType === 'light') {
      return navCollapsed ? '/img/KowrIcon.png' : '/img/Kowri_Logo-04.png';
    }
    return navCollapsed ? '/img/KowrIcon.png' : '/img/LightTheme.png';
  } else if (path === 'payjack') {
    if (logoType === 'light') {
      return navCollapsed ? '/img/payJack_btn.png' : '/img/payJack_logo.png';
    }
    return navCollapsed ? '/img/payJack_btn.png' : '/img/payJack_logo.png';
  }

  // Default logo set if the path does not match '/app' or '/app2'
  if (logoType === 'light') {
    return navCollapsed ? '/img/KowrIcon.png' : '/img/Kowri_Logo-04.png';
  }
  return navCollapsed ? '/img/KowrIcon.png' : '/img/LightTheme.png';
};


const getLogoDisplay = (isMobile, mobileLogo) => {
  if(isMobile && !mobileLogo) {
    return 'd-none'
  } else {
    return 'logo'
  }
}

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  return (
    <div
      className={getLogoDisplay(isMobile, props.mobileLogo)} 
      style={{width: `${getLogoWidthGutter(props, isMobile)}`}}>
      <img src={getLogo(props)} alt={`${APP_NAME} logo`} height={`50px`} />
    </div>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType } =  theme;
  return { navCollapsed, navType }
};

export default connect(mapStateToProps)(Logo);
